import React from 'react';

import './FormActions.less';

export interface FormActionsProps {
  disableContinue: boolean,
  disableSkip: boolean,
  onSkip: null | (() => void),
  submitButtonText: string,
}

function FormActions({
  disableContinue = false,
  disableSkip = false,
  onSkip = null,
  submitButtonText = 'Continue',
}: FormActionsProps): JSX.Element {
  return (
    <div className="form_actions">
      {onSkip && <button type="button" className="skip" onClick={onSkip} disabled={disableSkip}>Skip</button>}
      <button type="submit" className="continue" disabled={disableContinue}>{submitButtonText}</button>
    </div>
  );
}

export default FormActions;
